var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPdf = function SvgPdf(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43,
    height: 50,
    viewBox: "0 0 43 50",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M3.472 0h23.212L39 12v34.528A3.472 3.472 0 0 1 35.528 50H3.472A3.472 3.472 0 0 1 0 46.528V3.472A3.472 3.472 0 0 1 3.472 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#EBEBEB",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8D8D92",
    d: "M26.642 0L39 12h-8.886a3.472 3.472 0 0 1-3.472-3.472V0z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M30 12h9v9z",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 19,
    y: 22,
    fill: "#E13C37",
    rx: 2
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFF",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 12.5
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6,
    y: 37
  }, "PDF")))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPdf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pdf.1ba30d23c9a7f4bdd74291536667b535.svg";